import { Star } from '@tunasong/icons'
import cn from 'classnames'
import { type FC } from 'react'
import { IconButton, type IconButtonProps } from '../primitives/index.js'
import type { FavoriteControlProps } from './favorite-props.js'
import styles from './favorite.module.css'
import { useFavorites } from './favorites.hook.js'

type FavoriteIconProps = FavoriteControlProps<IconButtonProps>

export const FavoriteIcon: FC<FavoriteIconProps> = props => {
  const { onClick, entity, ...restProps } = props

  const { isFavorite, toggleFavorite, getFavoriteTemplateFromEntity } = useFavorites()

  const favorite = isFavorite(entity)

  return (
    <IconButton
      {...restProps}
      className={cn(styles.favoriteIcon, restProps.className)}
      color="inherit"
      aria-pressed={favorite}
      onClick={ev => {
        ev.preventDefault()
        ev.stopPropagation()
        const template = getFavoriteTemplateFromEntity(entity)
        toggleFavorite(template)
        if (onClick) {
          onClick(ev)
        }
      }}
      aria-label={favorite ? 'Remove from favorites' : 'Add to favorites'}
      style={{ flex: '0 0 auto', ...restProps.style }}
    >
      {/* Grey in both states; the fill says "favorited", so state never rests on colour */}
      <Star fill={favorite ? 'currentColor' : 'none'} />
    </IconButton>
  )
}

export default FavoriteIcon
